export default class AlertBanner {
	constructor( bannerSelector, closeSelector ) {
		this.banner = document.querySelector( bannerSelector );
		this.closeButton = this.banner?.querySelector( closeSelector );
		this.cookieName = 'alert_banner_closed';
		this.bannerVersion = this.banner?.dataset.bannerVersion || '';
		console.log( this.banner );

		if ( ! this.banner || ! this.closeButton ) {
			return;
		}

		this.init();
	}

	init() {
		if ( this.isCookieSet() ) {
			this.hideBanner();
			return;
		}
		this.showBanner();
		this.closeButton.addEventListener( 'click', () => this.handleClose() );
	}

	handleClose() {
		this.setSessionCookie();
		this.hideBanner();
	}

	setSessionCookie() {
		// Set a session cookie (no `expires` attribute means the cookie lasts for the session)
		document.cookie = `${ this.cookieName }=${ this.bannerVersion }; path=/`;
	}

	//display alert if the content gets updated
	isCookieSet() {
		// Check if the cookie matches the current banner version
		return document.cookie.split( '; ' ).some( ( cookie ) => cookie === `${ this.cookieName }=${ this.bannerVersion }` );
	}
	showBanner() {
		this.banner.classList.remove( 'hidden' );
	}
	hideBanner() {
		this.banner.classList.add( 'hidden' );
	}
}

// Initialize AlertBanner
document.addEventListener( 'DOMContentLoaded', () => {
	new AlertBanner( '#alert-banner', '#close-alert-banner' );
} );
